import Project from './Project'
import Status from './Status'

export default class Task {
  constructor() {
    this.name = ''
    this.description = ''
    this.estimated_time = ''
    this.started_at = ''
    this.completed_at = ''
    this.project_id = ''
    this.status_id = ''
    this.asset_id = ''
    this.priority_id = ''
    this.milestone_id = ''
    this.project = new Project
    this.status = new Status
    this.labels = []
    this.assignees = []
    this.time_spent = []
    this.comments = []
    this.activities = []
    this.todos = []
    this.files = []
    this.user = {
      profile: {}
    }
  }

  get payload() {
    return {...this, assignees: this.assignees.map(assignee => assignee.id)}
  }
}
